import React, { Component } from 'react';
import '../css/App.css';
import '../css/swagger-ui.css';
import SwaggerUI from 'swagger-ui';
import Config from '../organization_config.json';
import '../../node_modules/swagger-ui/dist/swagger-ui.css'
import '../css/swagger-overrides.css';
import { getBrandName } from '../utils/brand';

// https://editor.swagger.io/ to make changes without accientally publishing

class apiReference extends Component {
    constructor(props) {
        super(props);
        const host = window.location.host.toLowerCase();
        this.state = {
            organizationConfig: Config.orgData,
            definitionList: null,
            definitionLink: host.includes('greenline.works') ?
                '/integrations-swagger-gl.yaml' :
                '/integrations-swagger.yaml',
        };
        this.brandName = getBrandName();
        this.swaggerhub = this.swaggerhub.bind(this);
        this.getOrganizationData = this.getOrganizationData.bind(this);
        this.updateDefinitionLink = this.updateDefinitionLink.bind(this)
    }

    componentDidMount() {
        document.title = `API Reference · ${this.brandName} Docs`;
        SwaggerUI({
            domNode: document.getElementById('api-data'),
            url: this.state.definitionLink,
            // Show curl/Node/Python request snippets next to each endpoint
            requestSnippetsEnabled: true,
            requestSnippets: {
                generators: {
                    curl_bash: { title: 'cURL (bash)', syntax: 'bash' },
                    curl_powershell: { title: 'cURL (PowerShell)', syntax: 'powershell' },
                    curl_cmd: { title: 'cURL (CMD)', syntax: 'bash' },
                    node_native: { title: 'Node.js', syntax: 'javascript' },
                },
                defaultExpanded: true,
                languages: null,
            },
            // Sensible defaults
            deepLinking: true,
            displayRequestDuration: true,
            tryItOutEnabled: true,
            docExpansion: 'list',
            filter: true,
        });
    }

    swaggerhub(inputMethod, inputResource, inputParams) {
        let url = "";
        if (inputParams) {
            url = "https://api.swaggerhub.com/apis/" + inputResource + "?" + inputParams
        } else {
            url = "https://api.swaggerhub.com/apis/" + inputResource
        }

        return fetch(url, {
            method: inputMethod
        }).then(response => {
            if (response.ok) {
                return response.json()
            } throw new Error('There was an issue requesting the API')
        }).then(json => {
            return json
        })
    }

    getOrganizationData(organization) {
        let inputParams = "page=0&limit=10&sort=NAME&order=ASC";
        let inputResource = organization;

        this.swaggerhub('GET', inputResource, inputParams).then(response => {
            this.setState({
                definitionList: response.apis
            })
        })
    }

    updateDefinitionLink(newLink) {
        this.setState({
            definitionLink: newLink
        })
    }

    render() {

        return (
            <div id="api-data" className="doc-page" />
        );
    }
}

export default apiReference;